import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    width: "inherit",
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(3, 7),
      paddingRight: theme.spacing(9)
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(3),
      paddingRight: theme.spacing(5)
    },
    margin: "auto",
    backgroundColor: theme.kooee.backgrounds.primary,
    boxShadow: "none"
  },
  margin: {
    height: theme.spacing(3)
  },
  poor: {
    textAlign: "right"
  },
  good: {
    textAlign: "left"
  }
}));
